<template lang="pug">
  el-scrollbar.h-100
    Header
    el-main.pa-0.min-w12.ma-auto(:style="'background-color:#f9fcfe;min-height:'+h")
      div(style="height:60px")
      div.ma-auto(style="width:800px;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);border-radius:10px;border-top:4px solid #ff7429;")
        div.text-center.my-9.title.orange--text 选择你感兴趣的物料分类
        el-row.py-5.mb-9(type="flex" justify="center")
          el-col(:span="20")
            el-checkbox-group(v-model="checkedCls" @change="handleCheckedClsChange")
              el-row(justify="center" :gutter="20")
                el-col(:span="6" v-for="(cls,i) in material_class.children" :key="i")
                  el-checkbox.mb-5.w-100(:label="cls.id" :key="cls.id" border) {{cls.text}}
            div.my-6
              el-row(type="flex" justify="center" :gutter="20")
                el-col.text-left(:span="6")
                  el-button.w-100(@click="goto('/')") 暂不设置 
                el-col.text-right(:span="6") 
                  el-button.w-100.button-bg.white--text(@click="setInterested") 设置 
    Footer
</template>
<script>
export default {
  data() {
    return {
      h: "",
      checkedCls: [],
      isIndeterminate: false
    };
  },
  methods: {
    handleCheckAllChange(val) {
      let data = [];
      for (var i in this.material_class.children) {
        data.push(this.material_class.children[i].id);
      }
      this.checkedCls = val ? data : [];
      this.isIndeterminate = false;
    },
    handleCheckedClsChange(value) {
      let checkedCount = value.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.material_class.children.length;
    },
    async setInterested() {
      if (this.checkedCls.length == 0) {
        this.$notify({
          message: "请选择你感兴趣的物料分类",
          type: "error"
        });
        return false;
      }
      let res = await this.$api.supplier.setInterested(this.checkedCls);
      if (res) {
        this.$notify({
          message: "操作成功",
          type: "success"
        });
        this.$router.push("/");
      }
    },
    async getInterested() {
      let res = await this.$api.supplier.getInterested();
      if (res) {
        try {
          this.checkedCls = res.data;
          this.isIndeterminate =
            this.checkedCls.length > 0 &&
            this.checkedCls.length < this.material_class.children.length;
        } catch (e) {
          // eslint-disable-next-line no-empty
        }
      }
    }
  },
  mounted() {
    this.getInterested();
    this.h = document.body.clientHeight - 100 - 120 + "px";
  },
  created() {
    if (
      this.$store.state.token &&
      JSON.stringify(this.$store.state.material_class) == "{}"
    )
      this.getMaterialClass();
  }
};
</script>